import React, { useState } from 'react';
import { X, Plus, Trash2, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export function CrewManager({ open, crew, onAdd, onUpdate, onDelete, onClose }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  if (!open) return null;

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await onAdd({ name: name.trim(), phone: phone.trim() });
    setName(''); setPhone('');
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center z-50 sm:p-4" data-testid="crew-modal">
      <div className="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-md max-h-[95dvh] flex flex-col shadow-xl">
        <div className="flex items-center justify-between px-5 py-4 border-b">
          <h2 className="font-bold text-gray-900 flex items-center gap-2"><Users className="w-5 h-5 text-[#006400]" /> Your crew</h2>
          <button type="button" onClick={onClose} className="p-1.5 rounded-lg hover:bg-gray-100" aria-label="Close" data-testid="crew-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-3">
          <p className="text-xs text-gray-500">Just names — no logins needed. Tick who's on each block and filter the calendar by person.</p>
          {crew.length === 0 && <p className="text-sm text-gray-500 bg-gray-50 border border-dashed rounded-lg p-3 text-center" data-testid="crew-empty">No crew added yet.</p>}
          {crew.map((c) => (
            <div key={c.id} className="flex items-center gap-2 border rounded-lg p-2" data-testid={`crew-row-${c.id}`}>
              <input type="color" value={c.colour} onChange={(e) => onUpdate(c.id, { name: c.name, phone: c.phone || '', colour: e.target.value, active: c.active !== false })} className="w-8 h-8 rounded border-0 cursor-pointer" aria-label="Colour" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-gray-900 truncate">{c.name}</div>
                {c.phone && <div className="text-xs text-gray-500">{c.phone}</div>}
              </div>
              <button type="button" onClick={() => onDelete(c.id)} className="p-1.5 text-gray-400 hover:text-red-600" aria-label="Remove" data-testid={`crew-remove-${c.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
          <form onSubmit={add} className="flex gap-2 pt-1">
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" className="flex-1" data-testid="crew-name" />
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Mobile (optional)" className="w-36" data-testid="crew-phone" />
            <Button type="submit" size="sm" className="bg-[#006400] hover:bg-[#004d00] text-white h-10" data-testid="crew-add"><Plus className="w-4 h-4" /></Button>
          </form>
        </div>
      </div>
    </div>
  );
}
